import React from 'react';
import './SelectTravellerNumber.scss';

const DEFAULT_SIZE = 4;
import cx from 'classnames';
import Select from 'react-select';
import selectTheme from '../../../../../../../helpers/selectTheme';
import InputError from '../../../../InputError/InputError';

const Number = ({ number, handleSelectNumber, isSelected, numberSelected }) => {
  const handleClick = () => {
    handleSelectNumber(number);
  };

  return (
    <div
      className={cx('number', {
        'number--selected': isSelected,
        'number--other-num-selected': !isSelected && numberSelected,
      })}
      onClick={handleClick}
    >
      {number}
    </div>
  );
};
const SelectTravellerNumber = ({ input, meta, maxTravellers }) => {
  const numbers = [...Array(DEFAULT_SIZE).keys()];
  const numberOptions = [...Array(maxTravellers - DEFAULT_SIZE).keys()];
  const options = numberOptions.map((index) => {
    return {
      label: index + DEFAULT_SIZE + 1,
      value: index + DEFAULT_SIZE + 1,
    };
  });

  const handleSelectNumber = (value) => {
    input.onChange(value);
  };
  const handleSelectNumberOption = (option) => {
    input.onChange(option.value);
  };

  return (
    <>
      <div className={'select-traveller-number'}>
        <div className={'individual-number'}>
          {numbers.map((index) => {
            const number = index + 1;
            return (
              <Number
                key={index}
                number={number}
                handleSelectNumber={handleSelectNumber}
                isSelected={input.value === number}
                numberSelected={!!input.value}
              />
            );
          })}
        </div>

        <div className={'select-number'}>
          <div className={'select-number--label'}>5+ please select</div>
          <div className={'select-number--select'}>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={options}
              onChange={handleSelectNumberOption}
            />
          </div>
        </div>
      </div>
      <InputError meta={meta} />
    </>
  );
};
export default SelectTravellerNumber;
